import React from 'react'
import PropTypes from 'prop-types'

import axiosInstance from 'api/axios.config'
import { axiosPlain } from 'api'

import AloButton from '../../AloButton'
import CancellationQuestion from './CancellationQuestion'
import CancellationOfferModal from './CancellationOfferModal'

import './CancellationSurvey.scss'


const unexpectedError = "Oops, something went wrong. Please contact support@alomoves.com and we'll get to the bottom of it."

class CancellationSurvey extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showOfferModal: false,
      eligibleForOffer: false,
      error: null,
      action: null,
      modalMessage: undefined
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)
    this.handleModalConfirmCancel = this.handleModalConfirmCancel.bind(this)
    this.handleModalAcceptOffer = this.handleModalAcceptOffer.bind(this)
    this.onReasonChange = this.onReasonChange.bind(this)
    this.onDetailsChange = this.onDetailsChange.bind(this)
  }

  componentDidMount() {
    this.checkOffer()
  }

  detailsStateKey(questionKey, reasonKey) {
    return 'detailsText' + questionKey + ':' + reasonKey
  }

  buttonClicked(action) {
    this.setState({
      error: null,
      action
    })
  }

  processError(response) {
    let message
    if (!response || response.status >= 500) {
      message = unexpectedError
    } else {
      message = response.data.error || response.data.message || response.statusText
    }

    this.setState({
      error: message,
      action: null
    })
  }

  // 
  // API calls
  // 

  checkOffer() {
    // Get eligiblity status for cancellation offer
    axiosInstance
      .get('users/me/membership/stripe/cancellation_offer')
      .then(response => {
        this.setState({
          eligibleForOffer: response.data.eligible
        })
      })
      .catch(error => {
        // Fail silently
      })
  }

  acceptOffer() {
    axiosInstance
      .post('users/me/membership/stripe/cancellation_offer', {})
      .then(response => {
        if (response.data.status === 'unprocessable_entity') {
          this.processError(response)
        } else {
          // TODO: remove-candy-check -- hook into context provider refresh; maybe also close the modal?
          this.handleModalClose()
          this.props.closeCallback('offerAccepted')
          // Checking the offer here since they've accepted the offer at this point
          // and if they were to click the cancel button again, they should no longer
          // be eligible for the cancellation offer.
          this.checkOffer()
        }
      })
      .catch(error => {
        this.processError(error.response)
      })
  }

  submitSurvey() {
    // Prep form data
    let responses = []
    let reasonKey

    this.props.questions.forEach(question => {
      reasonKey = this.state['selectedReason' + question.key]

      if (reasonKey) {
        responses.push({
          question: question.key,
          reason: reasonKey,
          details: this.state[this.detailsStateKey(question.key, reasonKey)]
        })
      }
    })

    // Submit survey
    if (responses.length > 0) {
      axiosInstance
        .post('cancellation_surveys', {
          responses: responses
        })
        .catch(error => {
          // Fail silently
        })
    }
  }

  cancelMembership() {
    axiosPlain
      .delete('users/me/membership/stripe')
      .then((res) => {
        // TODO: remove-candy-check -- hook into context provider refresh; maybe also close the modal?
        this.props.closeCallback('cancelled')
        this.handleModalClose()
        if (res.data?.ga4_event) {
          window.dataLayer.push(res.data.ga4_event)
        }
      })
      .catch((error) => {
        this.processError(error.response)
      })
  }
  // 
  // Form handlers
  // 

  handleSubmit(e) {
    e.preventDefault()

    this.setState({
      showOfferModal: true
    })
  }

  // 
  // Modal handlers
  // 

  handleModalClose() {
    this.setState({
      showOfferModal: false,
      error: null,
      action: null
    })
  }

  handleModalConfirmCancel() {
    this.buttonClicked('cancel')
    this.submitSurvey()
    this.cancelMembership()
  }

  handleModalAcceptOffer() {
    this.buttonClicked('accept')
    this.acceptOffer()
  }

  // 
  // Input handlers (called by CancellationReason)
  // 

  onReasonChange(question, reason) {
    this.setState({
      ['selectedReason' + question.key]: reason.key
    })

    if (reason.modalMessage) {
      this.setState({
        modalMessage: reason.modalMessage
      })
    }
  }

  onDetailsChange(question, reason, val) {
    this.setState({
      [this.detailsStateKey(question.key, reason.key)]: val
    })
  }

  ///////////////////////////////////////////////////////////

  render() {
    return (
      <React.Fragment>
        <form className='CancellationSurvey' id='settings-cancellation-form' onSubmit={this.handleSubmit}>
          {this.props.questions.map(question => (
            <CancellationQuestion
              question={question}
              surveyState={this.state}
              detailsStateKey={this.detailsStateKey}
              onReasonChange={this.onReasonChange}
              onDetailsChange={this.onDetailsChange}
              key={question.key}
            />
          ))}
          <div className='button-container right'>
            <AloButton type='submit' className='CancellationSurvey--submit'>
              Cancel Membership
            </AloButton>
          </div>
        </form>

        <CancellationOfferModal
          eligible={this.state.eligibleForOffer}
          message={this.state.modalMessage}
          subcaption='Your free month will start at the end of your current billing period.'
          show={this.state.showOfferModal}
          onHide={this.handleModalClose}
          onConfirmCancel={this.handleModalConfirmCancel}
          onAcceptOffer={this.handleModalAcceptOffer}
          error={this.state.error}
          action={this.state.action}
        />
      </React.Fragment>
    )
  }
}

CancellationSurvey.propTypes = {
  questions: PropTypes.array.isRequired,
  closeCallback: PropTypes.func.isRequired
}

export default CancellationSurvey
